const AppColors = {
  primary: "#22b470",
  secondary: "#090d28",
  success: "#22b470",

  danger: "#ea3546",

  white: "#fff",
  light: "#f5f5f5",
  dark: "#232526",

  grey1: "#808697",
  grey2: "#6e6e6e",
  grey3: "#383838",
};

export { AppColors };
